import { Controller } from 'stimulus'

export default class extends Controller {
  open(event) {
    event.preventDefault()
    const modalId = event.currentTarget.dataset.modal
    const modal = document.getElementById(modalId)
    if (modal) {
      modal.classList.add('modal--is-active')
      modal.setAttribute('aria-hidden', 'false')
      modal.focus()
      this.data.set('id', modalId)
    }
  }

  close(event) {
    if (
      this.data.has('id') &&
      (event.keyCode === 27 || event.type === 'click')
    ) {
      const modalId = this.data.get('id')
      const modal = document.getElementById(modalId)
      if (modal) {
        modal.classList.remove('modal--is-active')
        modal.setAttribute('aria-hidden', 'true')
      }
      this.data.delete('id')
    }
  }
}
